function UserBackdrop(props) {
  return <div className="backdrop" onClick={props.onClick} />;
}

export default UserBackdrop;
